import type { PropsWithChildren, ReactNode } from 'react';

interface PanelProps {
  title?: string;
  description?: string;
  action?: ReactNode;
}

export function Panel({ children, title, description, action }: PropsWithChildren<PanelProps>): JSX.Element {
  return (
    <section className="panel">
      {(title || description || action) && (
        <header className="panel__header">
          <div>
            {title && <h3 className="panel__title">{title}</h3>}
            {description && <p className="panel__description">{description}</p>}
          </div>
          {action}
        </header>
      )}
      <div className="panel__body">{children}</div>
    </section>
  );
}

